
import {cookies, CookKey} from 'utils/cookies';
import {hasWindow} from 'utils/functions';
import {dataLayer} from 'utils/window/dataLayer';

// Global Privacy Control signal; not in lib.dom
declare global {
	interface Navigator {
		readonly globalPrivacyControl?: boolean;
	}
}

const OPT_OUT = '1';

// Same test as an inline JS expression, for pixel bootstrap scripts that need the opt-out
// before their init call; literal must match CookKey.PrivacyOptOut and gatsby-config.ts
export const OPT_OUT_INLINE =
	'(/(?:^|;\\s*)privacy-opt-out=1(?:;|$)/.test(document.cookie)||navigator.globalPrivacyControl===true)';

export const hasGPC = (): boolean => (
	hasWindow() && navigator.globalPrivacyControl === true
);

export const hasOptOutCookie = (): boolean => (
	cookies.get(CookKey.PrivacyOptOut) === OPT_OUT
);

export const readOptOut = (): boolean => hasGPC() || hasOptOutCookie();

// Vendor "service provider" signals for an opt-out that arrives mid-session (account sync);
// load-time signals are set inline by gatsby-config defaultDataLayer and Scripts/_Facebook
export const applyOptOut = () => {
	if (!hasWindow()) {
		return;
	}

	if (window.dataLayer?.push) {
		const gtag: (...args: unknown[]) => void = function () {
			// eslint-disable-next-line prefer-rest-params -- GTM requires the Arguments object itself
			window.dataLayer?.push?.(arguments);
		};
		gtag('consent', 'update', {
			ad_user_data: 'denied',
			ad_personalization: 'denied',
		});
	}

	// GTM variable; bound to Restricted Data Processing on the Google Ads tags
	dataLayer.push({privacyOptOut: true});

	// Meta documents this before init; later events still pick it up, so best effort here
	if (window.fbq) {
		const fbq = (window.fbq as (...args: unknown[]) => void);
		fbq('dataProcessingOptions', ['LDU'], 1, 1000);
	}
};

export const writeOptOut = () => {
	cookies.set(CookKey.PrivacyOptOut, OPT_OUT, {expires: 365});
	applyOptOut();
};
